import type { CustomResponseFormat } from "api/instance";

// 기록(생각기록지·명상훈련지) status/detail 쿼리 캐시에 done/undone 을 선반영한다.
// 완료 직후의 status 재조회는 리더 replica 지연으로 stale isDone 을 돌려줄 수 있어,
// 페이지의 자동 저장 게이트(isDone)가 서버 응답을 기다리지 않고 즉시 따라가게 한다.
// api/instance 는 type-only import 라 런타임 axios 로드 없음(jest ESM 회피).
export const applyDoneToStatus = <
  T extends { isDone: boolean; lastDoneAt?: string },
>(
  old: CustomResponseFormat<T> | undefined,
  isDone: boolean,
  nowIso: string
): CustomResponseFormat<T> | undefined => {
  if (!old?.result) return old;
  return {
    ...old,
    result: isDone
      ? { ...old.result, isDone: true, lastDoneAt: nowIso }
      : { ...old.result, isDone: false },
  };
};
